import React from 'react';
import ReportRegionInfo from '../../blocks/PageInfo/ReportRegionInfo';

import style from './RnkimContent.module.scss';

const ReportRegionContent = () => (
  <>
    <div className={style.container}>
      <ReportRegionInfo />
    </div>
    <div className={style.frame}>
      <iframe
        width="100%"
        height="100%"
        title="Visiology"
        src="https://pix.tektorg.ru/shared/view/a208d01b-7ce6-41ea-b65d-7b7d68d8839b"
      />
    </div>
  </>
);

export default ReportRegionContent;
